if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', function () {
  const variantSelectsList = document.querySelectorAll('variant-selects[data-no-auto-select="true"]');

  variantSelectsList.forEach(function (variantSelects) {
    const selects = variantSelects.querySelectorAll('select.select__select');
    if (!selects.length) return;

    const productForm =
      document.getElementById('product-form-' + variantSelects.dataset.section) ||
      variantSelects.closest('section')?.querySelector('product-form form') ||
      variantSelects.closest('section')?.querySelector('form[action*="/cart/add"]');

    if (!productForm) return;

    const variantIdInput = productForm.querySelector('input[name="id"]');
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton ? addButton.querySelector('span') || addButton : null;

    let variants = [];
    const json = variantSelects.querySelector('script[type="application/json"]');

    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      console.error('Variant JSON parse error:', e);
      return;
    }

    function setButtonState(disabled, text) {
      if (!addButton) return;
      addButton.disabled = disabled;
      addButton.classList.toggle('disabled', disabled);
      addButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');

      if (addButtonText && text) {
        addButtonText.textContent = text;
      }
    }

    function getSelectedOptions() {
      return Array.from(selects).map(function (select) {
        return select.value;
      });
    }

    function findVariant(selectedOptions) {
      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      });
    }

    function resetFormState() {
      if (variantIdInput) {
        variantIdInput.value = '';
      }

      setButtonState(true, 'Select options');
    }

    function updateVariant() {
      const selectedOptions = getSelectedOptions();
      const allChosen = selectedOptions.every(function (value) {
        return value !== '';
      });

      if (!allChosen) {
        resetFormState();
        return;
      }

      const matchedVariant = findVariant(selectedOptions);

      if (!matchedVariant) {
        if (variantIdInput) {
          variantIdInput.value = '';
        }
        setButtonState(true, 'Unavailable');
        return;
      }

      if (variantIdInput) {
        variantIdInput.value = matchedVariant.id;
      }

      if (!matchedVariant.available) {
        setButtonState(true, 'Sold out');
      } else {
        setButtonState(false, 'Add to cart');
      }

      if (variantSelects.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url);
      }
    }

    selects.forEach(function (select) {
      select.value = '';
      select.addEventListener('change', updateVariant);
    });

    resetFormState();
  });
});